import React from 'react';


class ProfileLoggedIn extends React.PureComponent {
  render() {
    return (
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xlinkHref="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 200 200"
        style={{ enableBackground: 'new 0 0 200 200', fill: 'white' }}
        xmlSpace="preserve"
      >
        <g>
          <g>
            <g>
              <path d="M100,103.4c-20.5,0-37.2-16.7-37.2-37.2S79.5,29,100,29s37.2,16.7,37.2,37.2S120.5,103.4,100,103.4z" />
            </g>
          </g>
          <path d="M60.9,171.1c-12.1,0-20.4-0.1-21-0.1c-0.3,0-0.7,0-1.3-0.1c-2.6-0.6-4.2-3.1-3.6-5.7l12.8-46.6c0.5-2.2,2.5-3.7,4.7-3.7
            h8.4h78.2h8.4c2.2,0,4.2,1.5,4.7,3.7l12.8,46.6c0.6,2.6-1,5.1-3.6,5.7c-0.6,0.1-1,0.1-1.3,0.1c-0.6,0-8.9,0-21,0.1H60.9z"
          />
        </g>
      </svg>
    );
  }
}

export default ProfileLoggedIn;
